import { css } from "@emotion/react";

export const removeClickOutline = css`
  &:focus:not(:focus-visible) {
    outline: none;
  }
`;
